import Box from '@mui/material/Box'

import {
    CustomTabsWithPadding,
    CustomTab,
    CustomTabPanelSmall,
} from '@/components/custom-tabs'
import useTabs from '@/hooks/use-tabs'
import MunicipalityFinancesList from './list'
import { YEARS_FROM_START_TO_THIS } from '@/constants/general'

function MunicipalityFinancesTabs() {
    
    const { tab, handleTabChange, a11yProps } = useTabs()

    return (
        <>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <CustomTabsWithPadding
                    value={tab}
                    onChange={handleTabChange}
                    aria-label="waste fee tabs"
                    variant="scrollable"
                    scrollButtons="auto"
                >
                    {YEARS_FROM_START_TO_THIS.map((year, index) => (
                        <CustomTab key={year} label={year} {...a11yProps(index)} />
                    ))}
                </CustomTabsWithPadding>
            </Box>
            {YEARS_FROM_START_TO_THIS.map((year, index) => (
                <CustomTabPanelSmall key={year} value={tab} index={index}>
                    <MunicipalityFinancesList year={year} />
                </CustomTabPanelSmall>
            ))}
        </>
    )
}

export default MunicipalityFinancesTabs
